var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Banner',{attrs:{"info":_vm.bannerInfo}}),_c('Dub'),_c('Adapter',{attrs:{"title":"DUB Series","adatpersInfo":_vm.dubSeries}}),_c('Adapter',{attrs:{"title":"M Series","adatpersInfo":_vm.mSeries}}),_c('div',{attrs:{"id":"videos"}},_vm._l((_vm.videosInfo),function(info,i){return _c('Video',{key:i,attrs:{"info":info}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }